'use strict';

(function () {

  angular.module('zp.mixes', []);
})();